/* FormValidationRules */
export default class FormValidationRules {
    constructor(el, options) {
        this.el = el;
        this.isValid = false;
        this.validators = {};
        this.defaults = this.getDefaultOptions();
        this.options = Object.assign(this.getDefaultOptions(), options);

        // Overwrite default messages with translations from formvalidator_translations if provided
        /*if (options && options.messages) {
            this.options.messages = Object.assign(this.defaults.messages, options.messages);
        }*/

        this.init();
    };

    getDefaultOptions() {
        return {
            fieldParentSelector: '.form__entry',
            groupParentSelector: '.form__fieldset',
            errorMessageClass: 'form__message',
            showSuccess: false,
            successMessageClass: 'form__success',
            messages: {
                required: 'This field is required',
                requiredSelect: 'An option must be selected',
                requiredCheckbox: 'This field is required',
                requiredCheckboxgroup: 'At least one option must be selected',
                requiredRadiogroup: 'An option must be selected',
                password: 'Must have 1 lower- and uppercase letter, 1 number and 1 symbol',
                minlength: 'The minimum length of this field is not met',
                maxlength: 'The content of this field is too long',
                email: 'This is not an email address',
                tel: 'This is not an phone number',
                min: 'The number must be at least %1$s or larger',
                max: 'The number must be %1$s or smaller',
            },
        };
    }

    validateRequired(el) {
        if (!el.value) {
            return false;
        }
        return true;
    };

    validateRequiredSelect(el) {
        if (el.selectedIndex === 0) {
            return false;
        }
        return true;
    };

    validateRequiredCheckbox(el) {
        if (!el.checked) {
            return false;
        }

        return true;
    };

    validateRequiredCheckboxgroup(el) {
        let group = el.dataset.group,
            siblings = document.querySelectorAll('[data-group="' + group + '"]'),
            checked = false;

        // Loop all in group, if one is checked, set checked to true
        for (let i = 0; i < siblings.length; i++) {
            if (siblings[i].checked) {
                checked = true;
                break; // loop no longer needs to continue
            }
        }

        return checked;
    };

    validateRequiredRadiogroup(el) {
        let name = el.name,
            siblings = document.querySelectorAll('[name="' + name + '"]'),
            checked = false;

        // Loop all in group, if one is checked, set checked to true
        for (let i = 0; i < siblings.length; i++) {
            if (siblings[i].checked) {
                checked = true;
                break; // loop no longer needs to continue
            }
        }

        return checked;
    };

    validatePassword(el) {
        if ((!el.required && el.value.length === 0) || el.dataset.validation === "false") {
            return true;
        }

        let regExLowerCase = /[a-z]/;
        let regExUpperCase = /[A-Z]/;
        let regExNumber = /\d/;
        let regExSymbols = /[-@#§£!"$€%^&*()_+|~=`{}\[\]:";'<>?,.\/]/;

        let hasLowerCase = regExLowerCase.test(el.value);
        let hasUpperCase = regExUpperCase.test(el.value);
        let hasNumber = regExNumber.test(el.value);
        let hasSymbols = regExSymbols.test(el.value);

        if (hasLowerCase && hasUpperCase && hasNumber && hasSymbols) {
            return true;
        }

        return false;
    };

    validateMinlength(el, arg) {
        // if (arg.length > 1 && arg[1] <= el.value.length) {
        //     return true;
        // } else if (el.getAttribute('minlength') <= el.value.length) {
        //     return true;
        // }

        let minLength = el.getAttribute('minlength');
        if (el.value.length >= minLength) {
            return true;
        }

        return false;
    };

    validateMaxlength(el, arg) {
        if (arg && arg.length > 1 && arg[1] > el.value.length) {
            return true;
        } else if (el.getAttribute('maxlength') > el.value.length) {
            return true;
        }

        return false;
    };

    validateEmail(el) {
        let regEx = /^([\w-\.\+]+@([\w-]+\.)+[\w-]{2,61})?$/;
        return regEx.test(el.value);
    };

    validateTel(el) {
        if (el.value.length == 0) {
            return true;
        }
        let regEx = /^[\+]?[\d]{9,13}$/;
        return regEx.test(el.value);
    };

    validateMin(el, arg) {
        if (parseInt(el.getAttribute('min')) <= parseInt(el.value)) {
            return true;
        }
        return false;
    };

    validateMax(el, arg) {
        if (parseInt(el.getAttribute('max')) >= parseInt(el.value)) {
            return true;
        }
        return false;
    };

    // Find nearest parrent with given selector
    findParent(el, selector) {
        while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, selector))) ;
        return el;
    };

    // Init
    init() {
        let isRequired = this.checkIfElementIsRequired(this.el);
        let ruleThatFailed = this.getValidationRuleOfElement(this.el);

        // Show error when validation failed
        if (ruleThatFailed) {
            this.showError(this.el, ruleThatFailed);
            if (this.options.showSuccess && isRequired) {
                this.hideSuccess(this.el);
            }

            return;
        }

        // If all is valid:
        // Also pass the ruleThatFailed, it determines the parent
        this.hideError(this.el);

        if (this.options.showSuccess && isRequired) {
            this.showSuccess(this.el);
        }

        this.isValid = true;
    };

    // Return the current validation rule needed for the el
    getValidationRuleOfElement(el) {
        // Validator rules:

        // Required
        if (el.matches('input:not([type=checkbox])[required]:enabled, textarea[required]:enabled') && !this.validateRequired(el)) {
            return 'required';
        }

        // Required
        if (el.matches('select[required]') && !this.validateRequiredSelect(el)) {
            return 'requiredSelect';
        }

        // Checkbox
        if (el.matches('input[type=checkbox]:not([data-group])[required]:enabled') && !this.validateRequiredCheckbox(el)) {
            return 'requiredCheckbox';
        }

        // Checkboxgroup
        if (el.matches('fieldset[data-required]:enabled input[type=checkbox]') && !this.validateRequiredCheckboxgroup(el)) {
            return 'requiredCheckboxgroup';
        }

        // Radiogroup
        if (el.matches('fieldset[data-required]:enabled input[type=radio]') && !this.validateRequiredRadiogroup(el)) {
            return 'requiredRadiogroup';
        }

        // password
        if (el.matches('input[type=password]:enabled:not([data-require-only-password])') && !this.validatePassword(el)) {
            return 'password';
        }

        // minlength
        if (el.matches('input[minlength]:enabled') && !this.validateMinlength(el)) {
            return 'minlength';
        }

        // maxlength
        if (el.matches('input[maxlength]:enabled') && !this.validateMaxlength(el)) {
            return 'maxlength';
        }

        // email
        if (el.matches('input[type=email]:enabled') && !this.validateEmail(el)) {
            return 'email';
        }

        // tel
        if (el.matches('input[type=tel]:enabled') && !this.validateTel(el)) {
            return 'tel';
        }

        // min
        if (el.matches('input[type=min]:enabled') && !this.validateMin(el)) {
            return 'min';
        }

        // max
        if (el.matches('input[type=max]:enabled') && !this.validateMax(el)) {
            return 'max';
        }

        // if no rule is found, return false
        return false;
    };

    // Checks ff the el is required
    checkIfElementIsRequired(el) {
        // inputs, checkboxes, textareas and selects that are required
        if (el.matches('input[required]:enabled, textarea[required]:enabled, select[required]')) {
            return true;
        }

        // Radiogroups and checkboxgroups
        if (el.matches('fieldset[data-required]:enabled input')) {
            return true;
        }

        // if no rule is found, return false
        return false;
    };

    showError(el, type) {
        let message = this.options.messages[type], // default error message
            parent,
            errorElement;

        // Find the parent to later append the error message to
        if (type === "requiredCheckboxgroup" || type === "requiredRadiogroup") {
            parent = this.findParent(el, this.options.groupParentSelector);
        } else {
            parent = this.findParent(el, this.options.fieldParentSelector);
        }

        if (!parent) {
            return;
        }

        // Find the errorElement
        errorElement = parent.querySelector('.' + this.options.errorMessageClass);

        // set attribute value on placeholder (mostly used for min and max values)
        if (message.search('%1') != -1) {
            message = message.replace('%1$s', el.getAttribute(type));
        }

        // Return if there's no message
        if (!message) {
            return;
        }

        // Set invalid class on parent
        parent.classList.add('-invalid');

        // Check if there is already an error message in the DOM
        if (!errorElement) {
            errorElement = document.createElement("span");
            errorElement.className = this.options.errorMessageClass;
            parent.appendChild(errorElement);
        }

        // Set error message
        errorElement.innerHTML = message;
    };

    hideError(el) {
        let parent,
            errorElement;

        // Find the parent to later remove the error message to
        if (el.matches('fieldset[data-required]:enabled input')) {
            parent = this.findParent(el, this.options.groupParentSelector);
        } else if (el.matches('fieldset:not([data-required]):enabled input')) {
            // checkbox/radio-groups that are not required do not need hiding error messages
            return;
        } else {
            parent = this.findParent(el, this.options.fieldParentSelector);
        }

        if (!parent) {
            return;
        }

        errorElement = parent.querySelector('.' + this.options.errorMessageClass);

        // Return when there's no errorElement
        if (!errorElement) {
            return;
        }

        // First, add a '-hide' class
        errorElement.classList.add('-hide');

        // Then remove the el entirely
        setTimeout(function () {
            parent.removeChild(errorElement);
        }, 710);

        parent.classList.remove('-invalid');
    };

    showSuccess(el) {
        let parent,
            successElement;

        // Find the parent to later append the success el to
        if (el.matches('fieldset[data-required]:enabled input')) {
            parent = this.findParent(el, this.options.groupParentSelector);
        } else {
            parent = this.findParent(el, this.options.fieldParentSelector);
        }

        if (!parent) {
            return;
        }

        // Find the successElement
        successElement = parent.querySelector('.' + this.options.successMessageClass);

        // Set success class on parent
        parent.classList.add('-success');

        // Check if there is already an error message in the DOM
        if (!successElement) {
            successElement = document.createElement("span");
            successElement.className = this.options.successMessageClass;
            parent.appendChild(successElement);
        }
    };

    hideSuccess(el) {
        let parent,
            successElement;

        // Find the parent to later remove the success message to
        if (el.matches('fieldset[data-required]:enabled input')) {
            parent = this.findParent(el, this.options.groupParentSelector);
        } else {
            parent = this.findParent(el, this.options.fieldParentSelector);
        }

        if (!parent) {
            return;
        }

        successElement = parent.querySelector('.' + this.options.successMessageClass);

        // Return when there's no successElement
        if (!successElement) {
            return;
        }

        // First, add a '-hide' class
        successElement.classList.add('-hide');

        // Then remove the el entirely
        setTimeout(function () {
            parent.removeChild(successElement);
        }, 710);

        parent.classList.remove('-success');
    };
};
